export const APPEARANCES = {
  default: 'default',
  danger: 'danger',
};
